import { render } from "./MobileDefault.vue?vue&type=template&id=439f479a&scoped=true"
import script from "./MobileDefault.vue?vue&type=script&lang=js"
export * from "./MobileDefault.vue?vue&type=script&lang=js"

import "./MobileDefault.vue?vue&type=style&index=0&id=439f479a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-439f479a"]])

export default __exports__